import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { STORAGE_KEYS } from '../../utils/storageKeys';

const AUTH_PROVIDER = import.meta.env.VITE_AUTH_PROVIDER || 'auth0';

/**
 * Detects Auth0 invitation parameters in the URL and redirects to the
 * custom invitation page. Skipped entirely for Authentik (Authentik manages
 * its own invitation/recovery UI outside the React app).
 */
const InvitationDetector = () => {
  const navigate = useNavigate();
  const [hasCheckedInvitation, setHasCheckedInvitation] = useState(false);

  useEffect(() => {
    // Authentik handles invitations through its own UI — skip entirely
    if (AUTH_PROVIDER === 'authentik') {
      setHasCheckedInvitation(true);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const invitation = params.get('invitation');
    const organization = params.get('organization');
    const organizationName = params.get('organization_name');

    if (invitation && organization) {
      const searchParams = new URLSearchParams();
      searchParams.set('invitation', invitation);
      searchParams.set('organization', organization);
      if (organizationName) {
        searchParams.set('organization_name', organizationName);
      }

      navigate(`/invite?${searchParams.toString()}`, { replace: true });
      localStorage.setItem(STORAGE_KEYS.PROCESSING_INVITATION, 'true');
    }

    setHasCheckedInvitation(true);
  }, [navigate]);

  if (!hasCheckedInvitation) {
    return null;
  }

  return null;
};

export default InvitationDetector;
